class MyOuAdminChangeTypeModal {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;
    this.lockIcon = require('Img/lock.svg');
  }

  $onInit() {
    console.log(this.resolve);
    this.ouTypes = this.resolve.ouTypes;
    this.selectedType = this.resolve.currentType;
  }

  submit() {
    this.close({ $value: this.selectedType });
  }

  cancel() {
    this.dismiss({ $value: 'cancel' });
  }
}

export const myOuAdminChangeTypeModalComponent = {
  template: require('./changeTypeModal.html'),
  controllerAs: 'ctrl',
  controller: MyOuAdminChangeTypeModal,
  bindings: {
    resolve: '<',
    close: '&',
    dismiss: '&',
  },
};